import { BRAND } from "@/config/brand";

// Blason officiel SanitDocs (image complète) : page d'entrée, Espace patient, écrans d'activation/installation.
export function Blason({ size = 120, className = "" }) {
  return <img src="/brand/blason.png" width={size} height={Math.round(size * 0.77)} alt={BRAND.name} data-testid="brand-blason" className={`select-none ${className}`} draggable={false} />;
}

// Variante simplifiée du blason (sans texte ni petits détails) : lisible en petit, identique aux icônes PWA.
export function LogoMark({ size = 40, className = "", onDark = false }) {
  const blue = "#0B3C8C", dark = "#072860", green = "#16A34A";
  const shield = "M50 4 L92 13 L92 50 Q92 84 50 96 Q8 84 8 50 L8 13 Z";
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" className={className} aria-label={BRAND.name} role="img">
      <path d={shield} fill={onDark ? "#FFFFFF" : dark} />
      <path d={shield} fill={onDark ? blue : "#FFFFFF"} transform="translate(50 50) scale(0.93) translate(-50 -50)" />
      <path d={shield} fill={blue} transform="translate(50 50) scale(0.86) translate(-50 -50)" />
      <path d="M34 26 h22 l10 10 v34 a3 3 0 0 1 -3 3 h-29 a3 3 0 0 1 -3 -3 v-41 a3 3 0 0 1 3 -3z" fill="#FFFFFF" />
      <path d="M56 26 v10 h10" fill="#C8D8F0" />
      <path d="M45 33 h6 v6 h6 v6 h-6 v6 h-6 v-6 h-6 v-6 h6z" fill={green} />
      <path d="M38 60 h20 M38 66 h14" stroke={blue} strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}

export function Logo({ size = 36, onDark = false, tagline = false, className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <LogoMark size={size} onDark={onDark} />
      <div className="leading-none">
        <span className={`font-heading font-extrabold tracking-tight block ${onDark ? "text-white" : "text-brand-800"}`} style={{ fontSize: size * 0.6 }}>
          {BRAND.name}
        </span>
        {tagline && <span className={`block mt-1 text-xs font-medium ${onDark ? "text-brand-100" : "text-slate-500"}`}>{BRAND.tagline}</span>}
      </div>
    </div>
  );
}
